let apiPathRoot = '' // hrmslite_

export default {
  name: 'TQM',

  systemId: 'HVS-TQM',

  apiVersion: '1.0.0.',

  masterDomain: 'admin', // Highest authority domain

  // When working in a local development environment, restful mockup server URL information
  // Later, when the development server is built, it will be moved there.
  //devUrl: 'http://localhost:8080',
  // devUrl: 'http://localhost:8085',
  devUrl: 'https://192.168.54.122:8097',  


   buildUrl: 'https://tqm.hd-hvs.com:8097',
  // buildUrl: 'http:///192.168.50.204:8088',

  // Websocket connection address
  websocketUrl: '',

  stompClient: null,

  framework: {
    // Whether to output detailed logs
    showDetailLog: false,
    // When working in a local development environment, whether to use Restful API server.
    // If false, use the default set provided by the framework as a mockup.
    useRestfulAPI: true,
    // When an error occurs, such as an API, whether to use the message format as a list within the error pop-up to be displayed globally.
    useErrorList: false,
    // Set to true if you use the mockup even after it is built.
    // Higher than useRestfulAPI. Even if the useRestfulAPI value is true, if this value is true, it is ignored.
    onlyMockup: false,
    // The framework must write a supported locale format.
    // This value is used as the ID of each Locale, and server inquiry and branching are performed.
    supportLocales: {
      ko: {
        id: 'ko',
        name: '한국어',
        image: require('@/assets/images/flags/ko.png')
      },
      en: {
        id: 'en',
        name: 'English',
        image: require('@/assets/images/flags/en.png')
      }
    },
    // The part that sets whether to retrieve i18n data from the server and apply it.
    // If true, the logic to query the server is performed, and if false, the default value of local is used without querying the server.
    getI18nDataFromServer: false,
    // global api path
    api_path: {
      menus: `${apiPathRoot}menus`, //Menu management api path
      programs: `${apiPathRoot}programs`, // program management api path
      filePath: `${apiPathRoot}file`, // file api path
      logPath: `${apiPathRoot}log`, // Connector management api path
      usermenuauths: `${apiPathRoot}usermenuauths` // Menu permission per user api path
    },
    template: {
      color: '',
      // Default values ​​to be used when using the theme (later stored and personalized in localStorage)
      pc: 'themeVuetify',
      mobile: 'themeVuetify',
      theme: 'light',
      // Whether to use the mobile theme. If you don't use it, only your PC will work.
      useMobile: true,
      // 1depth menu ID to be used as the default screen
      home: 'MN001',

      // Define theme list
      pcThemes: [{
        id: 'themeVuetify', // theme ID
        name: 'themeVuetify', // theme name
        component: () => import('@/layout/layout'), // Layout Vue file that defines the theme
        vuetify: 'themeVuetify',
        echart: 'blue', // Definition of theme name in echart
        layoutHideMode: false
      }]
    },
    // List of URL items that can be accessed even without logging in
    // whiteList: ['/v80Menu']
    whiteList: ['/login', '/logout', '/moceanLogin', '/autoLogin']
  }
}